import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagingNavItem } from '@hrra/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CustomerStatusEnum } from 'src/app/customer/shared/models/enums/customer-status-enum';
import { loadCvBoxApplications } from 'src/app/root-store/jobseeker-store/jobseeker-applies/actions';
import { selectCvBoxApplicationsDisplayPages, selectCvBoxApplicationsPageCount, selectCvBoxAppliesCurrentPage, selectJobseekerCvBoxApplications } from 'src/app/root-store/jobseeker-store/jobseeker-applies/selectors';
import { AppState } from 'src/app/root-store/state';
import { CvBoxApplication } from 'src/app/shared/models/cv-box-application-model';
import { CvBoxItemStatusEnum } from 'src/app/shared/models/enums/cv-box-item-status-enum';

@Component({
    selector: 'app-jobseeker-applies-cv-box',
    templateUrl: './jobseeker-applies-cv-box.component.html',
    styleUrls: ['./jobseeker-applies-cv-box.component.scss'],
    standalone: false
})
export class JobseekerAppliesCvBoxComponent implements OnInit {

  public applicationStatusNameMap = {
    [CvBoxItemStatusEnum.Pending]: 'label.Pending',
    [CvBoxItemStatusEnum.Approved]: 'label.Approved',
    [CvBoxItemStatusEnum.Rejected]: 'label.Rejected'
  };


  public cvBoxApplications$: Observable<CvBoxApplication[]>;
  public pageCount$: Observable<number>;
  public navItems$: Observable<PagingNavItem[]>;
  public currentPage$: Observable<number>;
  public isLoading$: Observable<boolean>;

  public cvBoxApplicationStatus: any;
  public customerStatus: any;

  constructor(private store: Store<AppState>, private route: ActivatedRoute, private router: Router) {
    this.cvBoxApplicationStatus = CvBoxItemStatusEnum;
    this.customerStatus = CustomerStatusEnum;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.store.dispatch(loadCvBoxApplications({payload: { page: 1 }}));
    }, 0);

    this.cvBoxApplications$ = this.store.pipe(select(selectJobseekerCvBoxApplications));
    this.pageCount$ = this.store.pipe(select(selectCvBoxApplicationsPageCount));
    this.navItems$ = this.store.pipe(select(selectCvBoxApplicationsDisplayPages));
    this.currentPage$ = this.store.pipe(select(selectCvBoxAppliesCurrentPage));
  }

  onPagignNavigation(page: number){
    this.store.dispatch(loadCvBoxApplications({payload: { page: page }}));
  }
}
